"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _DocumentedComponent = require("../../types/DocumentedComponent");

var _utils = require("../utils");

var _TooltipProvider = _interopRequireDefault(require("./TooltipProvider"));

var _TooltipTrigger = _interopRequireDefault(require("./TooltipTrigger"));

var _interfaces = require("./interfaces");

var _propTypes2 = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["isInline", "tooltipText", "tooltipPosition", "tooltipAlignment", "tooltipDataTestId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var withTooltip = function withTooltip() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultTooltipText = _ref.defaultTooltipText,
      triggerVerticalAlign = _ref.triggerVerticalAlign,
      _ref$useTriggerWrappe = _ref.useTriggerWrapper,
      useTriggerWrapper = _ref$useTriggerWrappe === void 0 ? true : _ref$useTriggerWrappe;

  return function (WrappedComponent) {
    var ComponentWithTooltip = function ComponentWithTooltip(_ref2) {
      var _ref2$isInline = _ref2.isInline,
          isInline = _ref2$isInline === void 0 ? false : _ref2$isInline,
          _ref2$tooltipText = _ref2.tooltipText,
          tooltipText = _ref2$tooltipText === void 0 ? defaultTooltipText : _ref2$tooltipText,
          tooltipPosition = _ref2.tooltipPosition,
          tooltipAlignment = _ref2.tooltipAlignment,
          tooltipDataTestId = _ref2.tooltipDataTestId,
          passthroughProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
      return (0, _core.jsx)(_TooltipProvider.default, {
        tooltipText: tooltipText || '',
        tooltipPosition: tooltipPosition,
        tooltipAlignment: tooltipAlignment,
        tooltipDataTestId: tooltipDataTestId
      }, function (_ref3) {
        var open = _ref3.open,
            close = _ref3.close,
            tooltipId = _ref3.tooltipId,
            triggerRef = _ref3.triggerRef,
            tooltipRef = _ref3.tooltipRef,
            isOpen = _ref3.isOpen;
        return (0, _core.jsx)(_TooltipTrigger.default, (0, _extends2.default)({
          isInline: isInline,
          WrappedComponent: WrappedComponent,
          useTriggerWrapper: useTriggerWrapper,
          tooltipDataTestId: tooltipDataTestId,
          isOpen: isOpen,
          open: open,
          close: close,
          tooltipId: tooltipId,
          triggerRef: triggerRef,
          tooltipRef: tooltipRef,
          verticalAlign: triggerVerticalAlign
        }, passthroughProps));
      });
    };

    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithTooltip.displayName = "withTooltip(".concat(displayName, ")");

    if (WrappedComponent.defaultProps) {
      ComponentWithTooltip.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    }

    var description = (0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent) ? WrappedComponent.documentation.toJSON().description : '';
    var DocumentedComponentWithTooltip = (0, _stencilReactDesc.describe)(ComponentWithTooltip).description(description);

    if ((0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent)) {
      var tooltipText = !!defaultTooltipText ? _stencilReactDesc.PropTypes.oneOfType(_propTypes2.tooltipTextTypes).description(_propTypes2.tooltipTextDescription) : _stencilReactDesc.PropTypes.oneOfType(_propTypes2.tooltipTextTypes).isRequired.description(_propTypes2.tooltipTextDescription);
      DocumentedComponentWithTooltip.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.describedPropTypes), {}, {
        tooltipText: tooltipText
      }, (0, _utils.omit)(_TooltipProvider.default.describedPropTypes, ['isInline', 'tooltipText', 'children']));
    } else if (WrappedComponent.propTypes) {
      var tooltipTextReactTypes = [_propTypes.default.element, _propTypes.default.string];

      var _tooltipText = !!defaultTooltipText ? _propTypes.default.oneOfType(tooltipTextReactTypes) : _propTypes.default.oneOfType(tooltipTextReactTypes).isRequired;

      ComponentWithTooltip.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
        tooltipText: _tooltipText,
        tooltipPosition: _propTypes.default.oneOf(Object.values(_interfaces.TOOLTIP_POSITION)),
        tooltipDataTestId: _propTypes.default.string
      });
    }

    return DocumentedComponentWithTooltip;
  };
};

var _default = withTooltip;
exports.default = _default;